'use client';

import React, { createElement, Fragment, ReactElement } from 'react';
import { classnames } from '@/utils/classnames/classnames';
import { asClassStyle } from '@/components/utils/helpers/variants';
import Skeleton from '../skeleton';
import { TypographyProps } from './types';
import { alignment, fontSizes, fontWeights, lineHeights } from './helpers/variants';

const Typography: React.FC<TypographyProps> = ({
  children,
  as = 'p',
  classStyle = 'b2',
  asSkeleton = false,
  fontSize,
  align,
  lineHeight,
  fontWeight,
  underline = false,
  className,
  ...props
}) => {
  const elementClassName = classnames(
    fontSize && (fontSizes(fontSize.toString()) as string),
    lineHeight && (lineHeights(lineHeight) as string),
    fontWeight && (fontWeights(fontWeight) as string),
    { underline },
    { relative: asSkeleton },
    { [alignment(align ?? '') as string]: !!align },
    'text-primary',
    asClassStyle(classStyle) as string,
    className,
  );

  // Constructing default props of the element
  const elementProps: ReactElement['props'] = {
    className: elementClassName,
    ...props,
  };

  const TypographyElement = createElement(
    as == 'fragment' ? Fragment : as,
    as !== 'fragment' && elementProps,
    <>
      {asSkeleton && <Skeleton fillMode />}
      {children}
    </>,
  );

  return TypographyElement;
};

export default Typography;
